import {RxCollection} from 'rxdb';
/* eslint-disable camelcase */
import {TimeTableResponse} from '../../../core/models';

export class TimetableCacheDataSource {
    constructor(public collection: RxCollection) {}

    public async removeExpiredEntries(): Promise<void> {
        const threshold = Date.now() - 1 * 24 * 60 * 60 * 1000; // 1 día
        const expiredDocs = await this.collection
            .find({selector: {fetched_at: {$lt: threshold}}})
            .exec();

        if (expiredDocs.length > 0) {
            const ids = expiredDocs.map((doc) => doc.primary);
            await this.collection.bulkRemove(ids);
        }
    }


    async saveTimetable(stopId: string, routeId: string, itineraries: any) {
        const id = `${stopId}::${routeId}`;
        const existing = await this.collection.findOne({selector: {id}}).exec();
        if (existing) return;
        const fetched_at = Date.now();
        await this.collection.insert({id, stop_id: stopId, route_id: routeId, itineraries_timetables: itineraries, fetched_at});
    }


    async getAllForStop(stopId: string): Promise<TimeTableResponse[]> {
        // 1) Traemos todos los docs de esta parada (incl. tombstones)
        const docs = await this.collection.find({selector: {stop_id: stopId}}).exec();

        // 2) Filtramos los tombstones (_deleted === true)
        const liveDocs = docs.filter((doc: any) => !doc.get('_deleted'));

        // 3) Mapear al formato TimeTableResponse
        return liveDocs.map((doc: any) => ({
            stop_id: doc.get('stop_id'),
            route_id: doc.get('route_id'),
            itineraries_timetables: doc.get('itineraries_timetables'),
        }));
    }

}

